import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoinTransactionState } from './coin-transaction.reducer';

export const selectCoinTransactionState = createFeatureSelector<CoinTransactionState>('coinTransaction');

export const selectCoinTransactions = createSelector(
  selectCoinTransactionState,
  (state) => state ? state.coinTransactions : null
);
